import React, { useState, useEffect } from "react";

import Table from "../common/Table";
import Option from "../common/RowOption";
import calc from "../../utils/calculation";

import lbl from "../../data/Labels.json";

const FinancePaymentsList = ({ activeYear, data }) => {
  const paymentsColumn = [
    { path: "id", label: "شماره" },
    { path: "payment_date", label: "تاریخ" },
    {
      path: "attachment",
      label: "سند",
      content: ({ attachment }) =>
        attachment && (
          <a href={attachment} download target="_blank">
            {lbl.Download}
          </a>
        ),
    },
    { path: "paid_by_staff", label: "پرداخت کننده" },
    { path: "remark", label: "ملاحظه" },
    { path: "amount", label: "مبلغ" },
    { path: "bank_ref_no", label: "ریفرنس نمبر" },
    {
      path: "option",
    },
  ];

  const [rows, getRows] = useState([]);

  useEffect(() => {
    if (data.data) {
      const filteredData = data?.data[0]?.payments.filter(
          (p) => p.half_year_id === (activeYear.half_year_id || activeYear)
      );

      getRows(filteredData);
    }
  }, [activeYear]);

  return (
    <div className="table-card">
      <p className="table-title">{lbl.Payments}</p>
      <Table
        data={rows}
        columns={paymentsColumn}
        total={rows && calc.getTotal(rows, "amount")}
      />
    </div>
  );
};

export default FinancePaymentsList;
